export default __webpack_public_path__ + "static/media/pets-chevron-right.d28b673e.svg";